import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';

import { formatNumber } from '../../../utils/generalFunctions';

import { setAlert } from '../../../actions/alert';
import { limpiarPaqueteConfiguracion, obtenerPaqueteConfiguracion, editarPaqueteConfiguracion } from '../../../actions/configuracion';
import { buscarLocatarios } from '../../../actions/locatarios';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const EditarPaquete = ({ paquete, reestablecerPaquete }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.configuracion.paquetes);
    const { listado: listado_locatarios } = useSelector(state => state.locatarios);

    const [editarModal, setEditarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [paqueteData, setPaqueteData] = useState({
        id: null,
        nombre: null,
        precio_calculado: 0, 
        precio: 0, 
        comision: 0, 
        descripcion: null, 
        servicios: []
    });

    const [locatariosData, setLocatariosData] = useState([]);
    const [locatariosFilter, setLocatariosFilter] = useState([]);

    const [serviciosData, setServiciosData] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided, 
        }),
        control: (provided, state) => ({
            ...provided,
            paddingTop: '5px',
            paddingBottom: '5px',
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Editar paquete */
    const handleAbrir = () => {
        dispatch(buscarLocatarios({
            nombre: null,
            servicio: null,
            status: null,
            fecha_inicio: null,
            fecha_fin: null
        }));
    }
    
    const handleInputChange = ({ target }) => {
        setPaqueteData({
            ...paqueteData,
            [target.name]: target.value
        });
    }

    const handleNumberChange = (name, value) => {
        setPaqueteData({
            ...paqueteData,
            [name]: value || ''
        });
    }

    /* Servicios */
    const handleAgregarServicio = () => {
        let servicios_totales = paqueteData.servicios;
        let locatarios = locatariosData;
        let servicios = serviciosData;

        servicios_totales.push({
            locatario: null, 
            servicio: null, 
            cantidad: 0
        });

        locatarios.push(null);
        servicios.push(null);

        setPaqueteData({
            ...paqueteData,
            servicios: servicios_totales
        });

        setLocatariosData(locatarios);
        setServiciosData(servicios);
    }

    const handleSelectLocatario = (option, posicion) => {
        let servicios_totales = paqueteData.servicios;
        let locatarios = locatariosData;
        let servicios = serviciosData;

        locatarios[posicion] = option;
        servicios[posicion] = null;

        servicios_totales[posicion].locatario = option ? option.value : null;
        servicios_totales[posicion].servicio = null;
        servicios_totales[posicion].cantidad = 0;

        setLocatariosData(locatarios);
        setServiciosData(servicios);

        let precio_calculado = 0;

        for (let x = 0; x < servicios_totales?.length; x++) {
            precio_calculado += parseFloat(servicios[x]?.precio || 0) * servicios_totales[x].cantidad;
        }

        setPaqueteData({
            ...paqueteData, 
            precio_calculado, 
            servicios: servicios_totales
        });
    }

    const handleSelectServicio = (option, posicion) => {
        let servicios_totales = paqueteData.servicios;
        let servicios = serviciosData;

        if (option && servicios.some((s, idx) => s?.value == option.value && idx != posicion)) {
            dispatch(setAlert('Este servicio ya está agregado', 'danger'));
            return;
        }

        servicios[posicion] = option;

        servicios_totales[posicion].servicio = option ? option.value : null;
        servicios_totales[posicion].cantidad = 0;

        setServiciosData(servicios);

        let precio_calculado = 0;

        for (let x = 0; x < servicios_totales?.length; x++) {
            precio_calculado += parseFloat(servicios[x]?.precio || 0) * servicios_totales[x].cantidad;
        }

        setPaqueteData({
            ...paqueteData, 
            precio_calculado, 
            servicios: servicios_totales
        });
    }

    const handleChangeCantidad = (posicion, { target }) => {
        if(target.value >= 0){
            let servicios_totales = paqueteData.servicios;

            servicios_totales[posicion].cantidad = parseFloat(target.value || 0);

            let precio_calculado = 0;

            for (let x = 0; x < servicios_totales?.length; x++) {
                precio_calculado += parseFloat(serviciosData[x].precio || 0) * servicios_totales[x].cantidad;
            }

            setPaqueteData({
                ...paqueteData,
                precio_calculado, 
                servicios: servicios_totales
            });
        }else{
            dispatch(setAlert('No puedes vender cantidades negativas', 'danger'));
        }
    }

    const handleEliminarServicio = (posicion) => {
        let servicios_totales = paqueteData.servicios;
        let locatarios = locatariosData;
        let servicios = serviciosData;

        servicios_totales.splice(posicion, 1);
        locatarios.splice(posicion, 1);
        servicios.splice(posicion, 1);

        let precio_calculado = 0;

        for (let x = 0; x < servicios_totales?.length; x++) {
            precio_calculado += parseFloat(servicios[x]?.precio || 0) * servicios_totales[x].cantidad;
        }

        setPaqueteData({
            ...paqueteData,
            precio_calculado, 
            servicios: servicios_totales
        });

        setLocatariosData(locatarios);
        setServiciosData(servicios);
    }
    
    /* Generales */
    const handleProcesar = async () => {
        if(paqueteData.nombre && paqueteData.servicios?.length){
            let cantidades_optimas = true;

            for (let x = 0; x < paqueteData.servicios?.length; x++) {
                if(!paqueteData.servicios[x].cantidad){
                    cantidades_optimas = false;
                }
            }

            if(cantidades_optimas){
                await setStatusProcesar(true);
                await dispatch(editarPaqueteConfiguracion(paqueteData));
                await handleCerrar();
                await setStatusProcesar(false);
            }else{
                await dispatch(setAlert('Cada servicio debe de tener una cantidad mayor a 0', 'danger'));
            }
        }else{
            await dispatch(setAlert('El nombre y al menos un servicio son necesarios', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setPaqueteData({
                id: null,
                nombre: null, 
                precio_calculado: 0, 
                precio: 0, 
                comision: 0, 
                descripcion: null, 
                servicios: []
            });

            setLocatariosData([]);
            setLocatariosFilter([]);
            setServiciosData([]);

            setEditarModal(false);
            reestablecerPaquete(null);
        }
    }

    /* Funciones generales */
    const createFilasServicios = () => {

        let servicios_campos = [];

        let servicios = paqueteData.servicios;

        if(servicios?.length > 0){
            for (let x = 0; x < servicios?.length; x++) {
                servicios_campos.push(
                    <div className="mb-3 row" key={'servicio_' + x}>
                        <div className="col-md-4">
                            <div className="input-group h-100">
                                <Select
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder={'Locatario ' + (x + 1)}
                                    options={locatariosFilter}
                                    value={locatariosData[x]}
                                    isClearable={true}
                                    isDisabled={paquete?.contrataciones}
                                    onChange={(value) => handleSelectLocatario(value, x)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{
                                        ValueContainer: CustomValueContainer
                                    }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>
                        <div className="col-md-5">
                            <div className="input-group h-100">
                                <Select
                                    className="select-group"
                                    classNamePrefix="react-select"
                                    placeholder={'Servicio ' + (x + 1)}
                                    options={locatariosData[x]?.servicios_ajustados || []}
                                    value={serviciosData[x]}
                                    isClearable={true}
                                    isDisabled={paquete?.contrataciones}
                                    onChange={(value) => handleSelectServicio(value, x)}
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    components={{
                                        ValueContainer: CustomValueContainer
                                    }}
                                    styles={{ ...styles_select }}
                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="input-group h-100">
                                <div className="form-floating">
                                    <input type="number" className="form-control" placeholder={'Cantidad ' + (x + 1)} value={servicios[x]?.cantidad} onChange={e => handleChangeCantidad(x, e)} disabled={!serviciosData[x] || paquete?.contrataciones} />
                                    <label className="font-weight-bold">{'Cantidad ' + (x + 1)}</label>
                                </div>

                                <div className="input-group-append">
                                    <button className="btn btn-danger deleteField" onClick={e => handleEliminarServicio(x)} disabled={paquete?.contrataciones}><i className="fa-solid fa-xmark"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }else{
            servicios_campos.push(
                <div className="col-md-12 pt-3 text-center">
                    <h5>Agrega servicios a este paquete</h5>
                </div>
            );
        }

        return servicios_campos;
    }

    useEffect(() => {
        dispatch(limpiarPaqueteConfiguracion());
    }, []);

    useEffect(() => {
        if(paquete){
            setEditarModal(true);
            
            dispatch(obtenerPaqueteConfiguracion(paquete?._id));

            setPaqueteData({
                ...paqueteData,
                id: paquete?._id
            });
        }
    }, [paquete]);

    useEffect(() => {
        if(detalles){
            let precio_calculado = 0;
            let servicios_paquete = [];
            let locatarios = [];
            let servicios = [];

            for (var i = 0; i < detalles?.servicios?.length; i++) {
                servicios_paquete.push({
                    locatario: detalles?.servicios[i].locatario?._id || null, 
                    servicio: detalles?.servicios[i].servicio?._id || null, 
                    cantidad: detalles?.servicios[i].cantidad || 0
                });

                let servicios_ajustados = [];

                for (var x = 0; x < detalles?.servicios[i].locatario?.servicios?.length; x++) {
                    servicios_ajustados.push({
                        value: detalles?.servicios[i].locatario?.servicios[x]._id, 
                        label: detalles?.servicios[i].locatario?.servicios[x].nombre + (detalles?.servicios[i].locatario?.servicios[x].precio ? ' (' + formatNumber(detalles?.servicios[i].locatario?.servicios[x].precio, 2, '$', '') + ')' : ''), 
                        precio: detalles?.servicios[i].locatario?.servicios[x].precio
                    });
                }

                locatarios.push( detalles?.servicios[i].locatario ? {
                    value: detalles?.servicios[i].locatario?._id, 
                    label: `${detalles?.servicios[i].locatario?.servicio?.nombre} (${detalles?.servicios[i].locatario?.nombre})`, 
                    servicios: detalles?.servicios[i].locatario?.servicios, 
                    servicios_ajustados
                } : null );

                servicios.push( detalles?.servicios[i].servicio ? {
                    value: detalles?.servicios[i].servicio?._id, 
                    label: detalles?.servicios[i].servicio?.nombre + (detalles?.servicios[i].servicio?.precio ? ' (' + formatNumber(detalles?.servicios[i].servicio?.precio, 2, '$', '') + ')' : ''), 
                    precio: detalles?.servicios[i].servicio?.precio
                } : null );

                precio_calculado += parseFloat(detalles?.servicios[i].servicio?.precio || 0) * (detalles?.servicios[i].cantidad || 0);
            }

            setPaqueteData({
                ...paqueteData,
                id: detalles?._id, 
                nombre: detalles?.nombre, 
                precio_calculado, 
                precio: detalles?.precio, 
                comision: detalles?.comision, 
                descripcion: detalles?.descripcion, 
                servicios: servicios_paquete
            });

            setLocatariosData(locatarios);
            setServiciosData(servicios);
        }
    }, [detalles]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_locatarios?.length; i++) {

            let servicios_ajustados = [];

            for (var x = 0; x < listado_locatarios[i].servicios?.length; x++) {
                servicios_ajustados.push({
                    value: listado_locatarios[i].servicios[x]._id, 
                    label: listado_locatarios[i].servicios[x].nombre + (listado_locatarios[i].servicios[x].precio ? ' (' + formatNumber(listado_locatarios[i].servicios[x].precio, 2, '$', '') + ')' : ''), 
                    precio: listado_locatarios[i].servicios[x].precio
                });
            }

            options.push({ value: listado_locatarios[i]._id, label: `${listado_locatarios[i].servicio} (${listado_locatarios[i].nombre})`, servicios: listado_locatarios[i].servicios, servicios_ajustados: servicios_ajustados });
        }

        setLocatariosFilter(options);
    }, [listado_locatarios]);

    return (
        <Modal show={editarModal} size="xl" backdrop="static" centered onEntered={() => handleAbrir()} onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Editar paquete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={paqueteData.nombre} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="nombre">Nombre</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-2 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <CurrencyInput
                                    className="form-control text-center"
                                    value={paqueteData.precio_calculado || 0}
                                    decimalsLimit={2}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    disabled={true}
                                />
                                <label htmlFor="precio">Precio calculado</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-2 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <CurrencyInput
                                    id="precio"
                                    name="precio"
                                    className="form-control text-center"
                                    value={paqueteData.precio}
                                    decimalsLimit={2}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    onValueChange={(value) => handleNumberChange('precio', value)}
                                />
                                <label htmlFor="precio">Precio</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-2 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <CurrencyInput
                                    id="comision"
                                    name="comision"
                                    className="form-control text-center"
                                    value={paqueteData.comision}
                                    decimalsLimit={2}
                                    groupSeparator=","
                                    decimalSeparator="."
                                    onValueChange={(value) => handleNumberChange('comision', value)}
                                />
                                <label htmlFor="comision">Comisión %</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Descripción" id="descripcion" name="descripcion" value={paqueteData.descripcion} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="descripcion">Descripción</label>
                            </div>
                        </div>
                    </div>

                    <hr className="my-4" />

                    { createFilasServicios() }
                </div>                   
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <>
                            <button type="button" className="btn btn-primary" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Servicio</button>
                            <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Guardar</button>
                        </>
                    :
                        <>
                            <button type="button" className="btn btn-primary" onClick={() => handleAgregarServicio()} disabled={paquete?.contrataciones}><i className="fas fa-plus fa-sm"></i> Servicio</button>
                            <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Guardar</button>
                        </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarPaquete;